export const isMobile = window.innerWidth < 1000;
export const isPortrait = window.innerWidth < window.innerHeight;
